import { useContext } from "react";
import { PageNewState, DeploymentRequestInfomationInputDialogContext } from ".";

export const useDeploymentRequestInfomationInputDialogState = () => {
  const { pageState, setPageState } = useContext(
    DeploymentRequestInfomationInputDialogContext,
  );
  return [
    pageState,
    (newState: PageNewState) => setPageState(newState),
  ] as const;
};
